<div class="ion-text-left border-radius">
  @if (label) {
    <ion-label [ngClass]="baseCssClass">
      {{ label }}
    </ion-label>
  }

  <ion-item
    [ngClass]="{ 'ion-margin-vertical': isMediumOrLarge() }"
    [disabled]="disabled || blocked"
    [lines]="disabled || blocked ? 'none' : 'full'">
    <ion-icon slot="start" name="calendar-outline" (click)="openCalendar()"></ion-icon>

    @if (dateForInput) {
      <ion-datetime-button
        [datetime]="'date-form-field-picked' + idSuffix"
        [ngClass]="baseCssClass"></ion-datetime-button>
    } @else {
      <ion-text class="date-placeholder" [ngClass]="baseCssClass" (click)="openCalendar()">
        {{ placeholder ?? "Select a date" }}
      </ion-text>
    }
    @if (errorText) {
      <ion-text class="error-text" color="danger">{{ errorText }}</ion-text>
    }
    <ion-popover #datePopover [keepContentsMounted]="true">
      <ng-template>
        <ion-datetime
          [value]="dateForInput"
          (ionChange)="onInputChange($event)"
          [min]="minDate"
          [multiple]="false"
          [id]="'date-form-field-picked' + idSuffix"
        presentation="date"></ion-datetime>
      </ng-template>
    </ion-popover>
  </ion-item>
</div>
